import { IPagedSearchParams, IQueryParams, SafeAny } from '@pf/shared-common';
import { forMember, mapFrom, MappingConfiguration } from '@automapper/core';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export const withWarehouseSearchFilter = <
    TDto extends IWarehouseEntity,
    TSearchParams extends IPagedSearchParams & { warehouseId?: string },
>(): MappingConfiguration<IQueryParams<TDto>, TSearchParams> => {
    return forMember(
        d => d.warehouseId,
        mapFrom(s => {
            return s.filters?.warehouse || (s.filters as SafeAny)?.warehouseId;
        })
    );
};
